module.exports = __webpack_public_path__ + "static/media/maintenance.fae42980.jpg";